<template>
  <div class="mb-4">
    <StatsList></StatsList>
  </div>
</template>

<script>
import StatsList from "@/components/Widgets/Statistics/StatsList.vue";
export default {
  name: "Stats",
  components: {
    StatsList,
  },
};
</script>

<style scoped lang="scss"></style>
